import { render } from "./index.vue?vue&type=template&id=e46df936"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/announcements-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e46df936"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e46df936', __exports__)) {
    api.reload('e46df936', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e46df936", () => {
    api.rerender('e46df936', render)
  })

}


export default __exports__